export const WISHLIST_LOCAL_STORAGE_KEY = 'wishList_room_id';
